<template>
  <div class="q-miss-word">
    <div>
      <div class="inline-words ta-center">
        <span v-for="(item, key) in data.metadata.variants" :key="key">
          <span v-if="item.type == 'simple'">
            <span 
              v-html="$options.filters.breakSpace(item.value)"
              class="q-miss-word-simple">
            </span>
          </span>
          <span v-if="item.type == 'answer'">
            <v-text-field 
              type="text" 
              v-model="answers_values[item.id]" 
              class="q-miss-word-answer q-input"
              :style="`width:${answers_values[item.id].length * 10.8}px;`" />
            <!-- <v-text-field 
              class="q-miss-word-answer"
              hide-details 
              type="text" 
              v-model="input_values[item.id]"
              :style="`width:${input_values[item.id]?.length * 10.8}px;`"
            /> -->
            
          </span>
        </span>
      </div>
      <div class="ta-center m-t-10 btn-content">
        <v-btn :loading="loading" @click="answer" class="mt-8" large color="info">
          Ответить на вопрос
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  props: {
    data: Object,
  },
  computed:{

  },
  created() {
    let cnt = 0;
    this.data.metadata.variants.forEach(el=>{
      if(el.type == 'answer'){
        el.id = cnt++
        this.answers_values.push('') // el.value
      }
    })
  },
  mounted(){
    
  },
  data() {
    return {
      answers_values: [],
      input_values: [],
      loading: false
    }
  },
  methods: {
    answer() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500);
    }
  },
}
</script>
